export default (theme) => ({
    root: {
        '& > div > svg, & > div > span, & > div > div': {
            margin: '0 0 15px 0',
        },
    },
    confirmText: {
        marginBottom: 20,
        whiteSpace: 'pre-wrap',
    },
    confirmLoading: {},
    confirmOverlay: {
        zIndex: '1001 !important',
    },
    confirmInput: {},
    confirmAdvice: {
        marginBottom: 20,
    },
    errorAdvice: {
        marginBottom: 20,
    },
});
